import api from '../common/api/reportingApi';

const basePath = '/report/account';
const baseAccountsPath = '/report/getallaccounts';
const baseBillingOfAccountPath = '/report/getbilling';
const domainsBasePath = '/report/domains';
const licensingBasePath = '/report/licensing';
const licensingBuyerBasePath = '/report/licensing/buyer';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },

  getAccounts(params = {}) {
    return api.get(baseAccountsPath, { params });
  },

  getBillingOfAccount(filters, params = {}) {
    return api.get(`${baseBillingOfAccountPath}/${filters.accountId}/${filters.month}/${filters.year}`, { params });
  },

  domainsReport(params = { }) {
    return api.get(domainsBasePath, { params });
  },

  getLicensingReport(params = {}) {
    return api.get(licensingBasePath, { params });
  },

  generateLicensingReport(body = {}) {
    return api.post(`${licensingBasePath}/generate`, body);
  },

  getBuyerLicensingReport(params = {}) {
    return api.get(licensingBuyerBasePath, { params });
  },

  getFinancialSummary(params = {}) {
    return api.get('/report/financial-summary', { params });
  },

  updateAccountFeeConfig(accountId, body) {
    return api.put(`/report/financial-summary/fee-config/${accountId}`, body);
  }
};




// WEBPACK FOOTER //
// ./src/services/reportService.js